// extracted by mini-css-extract-plugin
export default {"customButton":"ButtonComp_customButton__QAaJA"};